<template>
  <b-modal
    size="lg"
    centered
    no-close-on-backdrop
    ok-title="Enviar"
    id="modal-1"
    modal
    :title="$ml.get('registerMessage')"
  >
    <div class="m-3">
      <div class="d-flex justify-content-between align-items-baseline">
        <input
          class="form-control filterInput col-12 mb-3"
          v-model="title_message"
          :placeholder="$ml.get('placeholderTitleMessage')"
          aria-label="Search"
        />
        <multiselect
          v-if="
            listOptions.filter((it) => !message_type.includes(it.id)).length
          "
          class="col-11"
          v-model="optionSelected"
          :options="listOptions.filter((it) => !message_type.includes(it.id))"
          :searchable="false"
          label="name"
          :close-on-select="true"
          :custom-label="nameLang"
          :show-labels="false"
          :allow-empty="false"
          :preselect-first="true"
          :multiple="false"
          :placeholder="$ml.get('select')"
        ></multiselect>
        <div v-else>
          <span
            style="
              background: rgb(255 166 0 / 44%);
              padding: 1px 10px;
              font-weight: 400;
            "
            >Já foi cadastrado mensagem para todos os tipos</span
          >
        </div>
      </div>
      <div
        v-if="optionSelected.id === 'comment'"
        class="custom-control custom-checkbox mb-3 box-automatic-message"
        v-b-tooltip.hover
        :title="$ml.get('automaticMessage')"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          v-model="automaticMessage"
        />
        <label
          class="custom-control-label"
          v-text="$ml.get('labelAutomatic')"
        ></label>
      </div>
      <textarea
        id=""
        class="form-control w-100 text-are-mark"
        rows="7"
        v-model="description_message"
        :placeholder="$ml.get('placeholderTextAreaMessage')"
      >
      </textarea>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <b-button
        style="background: #730ba9"
        size="sm"
        @click="registerMessage(ok)"
      >
        {{ $ml.get("btnRegister") }}
      </b-button>
      <b-button
        class="float-right btn-outline-extra"
        size="sm"
        variant="primary"
        @click="cancel(), cancelMessage()"
      >
        {{ $ml.get("cancel") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import Swal from "sweetalert2";
import CompanyService from "../../../services/company.service";
export default {
  name: "ModalRegisterMessage",

  props: {
    message_type: {
      type: Array,
      required: false,
      default: Array,
    },
  },

  data() {
    return {
      title_message: "",
      description_message: "",
      automaticMessage: false,

      optionSelected: { name: "select_option", id: "select_option" },

      listOptions: [
        { name: "comment", id: "comment" },
        { name: "needs_information", id: "waiting_for_information" },
        { name: "under_review", id: "under_review" },
        { name: "triaged", id: "triaged" },
        { name: "retest_requested", id: "retest_requested" },
        { name: "bounty_paid", id: "bounty_paid" },
        { name: "close_as_approved", id: "close_as_approved" },
        { name: "close_as_informative", id: "close_as_informative" },
        { name: "close_as_spam", id: "close_as_spam" },
        { name: "close_as_duplicated", id: "close_as_duplicated" },
        { name: "close_as_not_applicable", id: "close_as_not_applicable" },
      ],
    };
  },
  methods: {
    registerMessage(okModal) {
      if (
        this.optionSelected.id == "select_option" ||
        this.title_message === "" ||
        this.description_message == ""
      ) {
        return;
      }

      const payload = {
        title: this.title_message,
        message: this.description_message,
        type: this.optionSelected.id,
      };

      if (this.optionSelected.id === "comment") {
        payload.is_automatic = this.automaticMessage ? "yes" : "no";
      }

      if (!this.title_message || !this.description_message) {
        return;
      }

      CompanyService.postMessageDefault(payload)
        .then((response) => {
          this.$emit("update-data");

          if (response.data === "Mensagem salva!") {
            Swal.fire({
              icon: "success",
              title: this.$ml.get("alertMessageSuccess"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            this.optionSelected = {
              name: "select_option",
              id: "select_option",
            };
            this.description_message = "";
            this.title_message = "";
            this.automaticMessage = false;
            okModal();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    cancelMessage() {
      this.description_message = "";
      this.title_message = "";
    },

    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },
  },
};
</script>
<style scoped>
.box-automatic-message {
  width: 130px;
}
</style>
